import { DocumentFieldValue } from "@ctv/shared-core/src";
import { RegistrationRequest, SaveAndExitRequest } from "../../apis";
import { RegistrationFormValue } from "../../types";

export function handleProcessDataBeforeSubmit(
  value: RegistrationFormValue
): Omit<SaveAndExitRequest, "token"> {
  const documents: RegistrationRequest["documents"] = [];
  if (value.document) {
    const documentObj = value.document!;
    Object.keys(documentObj).forEach((doc) => {
      if (documentObj[doc]) {
        const v = (
          !Array.isArray(documentObj[doc])
            ? [documentObj[doc]]
            : documentObj[doc]
        ) as DocumentFieldValue[];

        documents.push(
          ...v.map((d) => ({
            documentType: doc,
            fileName: d.url,
          }))
        );
      }
    });
  }

  const agreementDocuments: RegistrationRequest["agreementDocuments"] = [];
  if (value.agreementDocument) {
    const documentObj = value.agreementDocument!;
    Object.keys(documentObj).forEach((doc) => {
      if (documentObj[doc]) {
        agreementDocuments.push({
          documentType: doc,
          fileName: documentObj[doc].url,
        });
      }
    });
  }

  const {
    phone,
    companyName,
    officePhone,
    companyIndustry,
    partnerCompanyPhone,
    tnc: _, // Not used for payload
    picEmail: __, // Not used for payload
    ...rest
  } = value;

  return {
    ...rest,
    documents,
    agreementDocuments,
    corporateName: value.companyName,
    corporateIndustry: value.companyIndustry,
    picPhone: value.phone.phone,
    picPhoneCountryCode: value.phone.prefix,
    officePhone: value.officePhone.phone,
    officePhoneCountryCode: value.officePhone.prefix,
    partnerCompanyPhone: value.partnerCompanyPhone.phone,
    partnerCompanyPhoneCountryCode: value.partnerCompanyPhone.prefix,
  };
}
